import { FC } from 'react';
import { connect } from 'react-redux';
import { DropResult } from 'react-beautiful-dnd';
import i18next from 'i18next';

import { changeOptionPosition, setNewAttributeOptionList } from '~src/modules/attributes/actions/attributes.actions';
import DragList from '~src/shared/lists/dragList/DragList';
import logger from '~src/services/logger/LlsLogger';
import { AttributeOptionI } from '~src/interfaces/attributes.types';
import TileHeader from '~src/shared/headers/tileHeader/TileHeader';
import { ApiReduxResp } from '~src/services/apiMiddleware';
import { getCompanyContentLocale } from '~src/services/session';
import { StoreI } from '~src/rootReducer';

import AttributeOptionListItem from './AttributeOptionListItem';

interface StateProps {
  defaultContentLocale: string;
  contentLocales: { [key: string]: string };
}

interface OwnProps {
  t: i18next.TFunction;
  valueList: AttributeOptionI[] | [];
  attributeName: string;
  attributeId: string;
}

interface DispatchProps {
  setNewAttributeOptionList(attrId: string, list: AttributeOptionI[]): ApiReduxResp;
  changeOptionPosition(optionId: string, sendItem: { position: number }): ApiReduxResp;
}

type Props = OwnProps & DispatchProps;

const AttributeOptionList: FC<Props> = props => {
  const onListChange = (newList: AttributeOptionI[], result: DropResult) => {
    const sendItem = {
      position: 1,
    };

    if (result.destination) {
      sendItem.position = result.destination.index + 1;
    }
    props.setNewAttributeOptionList(props.attributeId, newList);
    props.changeOptionPosition(result.draggableId, sendItem).catch(error => {
      logger.info('Error change attributesoptions order', {
        error,
        info: {
          componentStack: 'AttributeOptionList.jsx',
        },
      });
    });
  };

  const renderListItem = (item: AttributeOptionI) => (
    <AttributeOptionListItem t={props.t} attributeId={props.attributeId} item={item} />
  );

  const { t, valueList = [], attributeName } = props;
  return (
    <>
      <TileHeader
        title={`${attributeName} (${valueList.length})`}
        titleKey="BE"
        tooltip={{
          txt: t('x.attributes.details.option.list.header'),
          key: 'x.attributes.details.option.list.header',
        }}
        withBg
      />
      <DragList renderTemplate={renderListItem} list={valueList} onListChange={onListChange} listKey="uuid" />
    </>
  );
};

const mapDispatchToProps = (dispatch: any): DispatchProps => ({
  setNewAttributeOptionList: (attributeId, newList) =>
    dispatch(setNewAttributeOptionList(attributeId, newList)),
  changeOptionPosition: (optionId, sendItem) => dispatch(changeOptionPosition(optionId, sendItem)),
});

const mapStateToProps = (state: StoreI): StateProps => ({
  defaultContentLocale: getCompanyContentLocale(state),
  contentLocales: state.user.session.contentLocales,
});

const AttributeOptionListC = connect(mapStateToProps, mapDispatchToProps)(AttributeOptionList);

export default AttributeOptionListC;
